import { PhoneOrderBadge } from "../../common/status-badge/StatusBadge";

export interface IPhoneOrderProps {
    hasOpenPhoneOrder: boolean;
}

export const PhoneOrderDisplay = (props: IPhoneOrderProps) => {
    if (props.hasOpenPhoneOrder) {
        return (
            <PhoneOrderBadge />
        );
    } 

    return <></>;
};
